import { CloseIcon } from "@/components/Icons";
import Tabs from "@/components/Tabs";
import { format } from "date-fns";
import { FantasyPointChart } from "./FantasyPointChart";
import { Prize } from "./Prize";

interface RoundInfoProps {
  sportName: string;
  roundId: string;
  sportEventStartTime: number;
  onClose: () => void;
}

export const RoundInfo = ({ sportName, roundId, sportEventStartTime, onClose }: RoundInfoProps) => {
  return (
    <div
      className="fixed inset-0 z-50 bg-background backdrop-blur-sm px-2 py-4 overflow-y-scroll"
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
    >
      <div className="flex justify-center pb-2 w-full">
        <p className="text-white">{sportName}</p>
        <CloseIcon className="absolute right-4 top-4" onClick={onClose} />
      </div>
      <p className="text-[#ADADAD] text-sm text-center mb-6">
        {format(new Date(sportEventStartTime), "MMMM d HH:mm'~'")}
      </p>
      <Tabs>
        <Tabs.Item title="Prizes">
          <Prize roundId={roundId} />
        </Tabs.Item>
        <Tabs.Item title="Player Score Chart">
          <FantasyPointChart />
        </Tabs.Item>
      </Tabs>
    </div>
  );
};
